export const userRecordStatus = [
  { key: "O", badgeColor: "badge-soft-success" },
  { key: "C", badgeColor: "badge-soft-danger" },
];

export const userRecordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};

export const userModeList = {
  VIEW_USER_DETAIL: "VIEW_USER_DETAIL",
  EDIT_USER_DETAIL: "EDIT_USER_DETAIL",
};

export const BU_METHOD_TYPE_SIGN = {
  TYPE_SIGN_HSM: "1",
  TYPE_SIGN_USB_TOKEN: "2",
};

export const emailPrefix = "@fecredit.com.vn";
